import { render } from "./Specifications.vue?vue&type=template&id=6502ca04&scoped=true&ts=true&lang=pug"
import script from "./Specifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./Specifications.vue?vue&type=script&setup=true&lang=ts"

import "./Specifications.vue?vue&type=style&index=0&id=6502ca04&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6502ca04"]])

export default __exports__